import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import { ThemeContext } from './contexts/ThemeContext';
import { Main, BlogPage, ProjectPage, } from './pages'
import { Achievement, BackToTop } from './components'
import ScrollToTop from './utils/ScrollToTop'
import Error from './components/Error/error'

import './App.css'

function App() {

  const { theme } = useContext(ThemeContext);

  console.log("%cSIMRAT SINGH", `color:${theme.primary}; font-size:50px`);
  console.log("%chttps://github.com/SIMRAT007", `color:${theme.tertiary}; font-size:20px`);
  // console.log = console.warn = console.error = () => {};

  return (
    <div className="app">
      <Router>
        <ScrollToTop/>
        <Switch>
          <Route path="/" exact component={Main} />
          <Route path="/blog" exact component={BlogPage} />
          <Route path="/projects" exact component={ProjectPage} />
         
          <Route path="*" exact component={Error}/>
          <Redirect to="/" />
        </Switch>
      </Router>
      <BackToTop />
      <div><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6656762161988524"
     crossorigin="anonymous"></script></div>

    
    </div>
  );
}

export default App;
